export const SECONDS_TEXT = 'Check your rate in seconds!';

export const PRIMARY_STEPS = {
  PRIMARY_DOB: '/primary-dob',
  PRIMARY_INCOME: '/primary-income',
  PRIMARY_NAME: '/primary-name',
  PRIMARY_ADDRESS: '/primary-address',
  PRIMARY_LIVING: '/primary-living',
  PRIMARY_PHONE: '/primary-phone',
};

export const SECONDARY_STEPS = {
  SECONDARY_NAME: '/secondary-name',
  SECONDARY_ADDRESS: '/secondary-address',
  SECONDARY_DOB: '/secondary-dob',
  SECONDARY_INCOME: '/secondary-income',
  SECONDARY_LIVING: '/secondary-living',
  SECONDARY_EMAIL: '/secondary-email',
};

export const STEPS = {
  LOAN_INTENT: '/loan-intent',
  LOAN_TYPE: '/loan-type',
  EMAIL: '/email',
  PASSWORD: '/password',
  CONTINUE_APP: '/continue-app',
  SSN: '/ssn',
  AGREEMENTS: '/agreements',
  LOAN: '/loan',
  ...PRIMARY_STEPS,
  ...SECONDARY_STEPS,
  BORROWER_HISTORY: '/borrower-history',
  CONFIRM_COBORROWER: '/confirm-coborrower',
  APP_TYPE: '/app-type',
};

export const STEP_FLOWS = {
  FULL_PREQUAL_INDIVIDUAL: 'FULL_PREQUAL_INDIVIDUAL',
  FULL_PREQUAL_JOINT: 'FULL_PREQUAL_JOINT',
  PARTIAL_PREQUAL_INDIVIDUAL: 'PARTIAL_PREQUAL_INDIVIDUAL',
  PARTIAL_PREQUAL_JOINT: 'PARTIAL_PREQUAL_JOINT',
  DM_EXPERIAN: 'DM_EXPERIAN',
  DM_EXPERIAN_PARTIAL_PII: 'DM_EXPERIAN_PARTIAL_PII',
  DM_INDIVIDUAL: 'DM_INDIVIDUAL',
  DM_JOINT: 'DM_JOINT',
  '2NDLOAN_INDIVIDUAL': '2NDLOAN_INDIVIDUAL',
  '2NDLOAN_JOINT': '2NDLOAN_JOINT',
  SSNUNHAPPY: 'SSNUNHAPPY',
  CONTINUE_APP: 'CONTINUE_APP',
  ERROR_LOGGED_IN: 'ERROR_LOGGED_IN',
  ERROR_LOGGED_OUT: 'ERROR_LOGGED_OUT',
  DEFAULT: 'DEFAULT',
};

export const FLOW_ERRORS = {
  REJECTED_BORROWER: 'REJECTED_BORROWER',
  LOAN_APP_IN_PROGRESS: 'LOAN_APP_IN_PROGRESS',
};

export const PI1_STEPS_ORDER = {
  MAIN: {
    PRIMARY: [
      STEPS.PRIMARY_NAME,
      STEPS.EMAIL,
      STEPS.PASSWORD,
      STEPS.PRIMARY_ADDRESS,
      STEPS.PRIMARY_DOB,
      STEPS.PRIMARY_PHONE,
      STEPS.PRIMARY_INCOME,
      STEPS.PRIMARY_LIVING,
      STEPS.LOAN_INTENT,
      STEPS.LOAN_TYPE,
    ],
    SECONDARY: [
      STEPS.SECONDARY_NAME,
      STEPS.SECONDARY_EMAIL,
      STEPS.SECONDARY_ADDRESS,
      STEPS.SECONDARY_DOB,
      STEPS.SECONDARY_INCOME,
      STEPS.SECONDARY_LIVING,
    ],
  },
};

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pi1-1QAAT.scss');